import type { TLoansContactCustomerData } from 'shared/types/TLoansService';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import { Auto, Contacts, CreditPurpose, Passport } from 'entities/creditForm/lib/formatters';

export const formDataToLoansContactCustomerAdapter = (
  formData: Partial<TCreditFormCommonFields>,
): TLoansContactCustomerData => {
  const auto = new Auto(formData).loans();
  const passport = new Passport(formData).loans();
  const contacts = new Contacts(formData).loans();
  const creditPurpose = new CreditPurpose(formData).map();

  return {
    fullName: passport.fullName,
    gender: passport.gender,
    ...contacts,
    ...auto,
    ...creditPurpose,
  };
};
